import React from "react";
import "./downloadApp.css";
import andriod from "../../../Assets/andriod12.png";

const DownloadAPK = () => {
  return (
    <div className="app-button">
      
      <a
        href="
          http://myovest.com/app/download
          "
        target="_blank"
      >
      <img src={andriod} alt="" className="" />

      </a>
      {/* <img src={playstore} alt="" className="playstore" /> */}

      {/* 
        <button>
          <i class="fas fa-download"></i>
          Download APK
        </button>
      </a> */}
    </div>
  );
};

export default DownloadAPK;
